import { useParams } from 'react-router-dom';
import { useGetSPOByProjectQuery } from '../../../store/api/spoApi';

interface UseResolvedSpoIdOptions {
  projectId?: string;
  spoId?: string;
}

interface UseResolvedSpoIdResult {
  projectId?: string;
  resolvedSpoId?: string;
  isResolving: boolean;
  isResolveError: boolean;
}

/**
 * 统一处理 SPO 子页面在两种路由上下文下的 ID 解析：
 * 1) /spo/:spoId/*
 * 2) 项目工作流内传入 projectId（先查 /spo/project/:projectId 获取 spoId）
 */
export const useResolvedSpoId = (
  options: UseResolvedSpoIdOptions = {}
): UseResolvedSpoIdResult => {
  const { projectId: routeProjectId, spoId: routeSpoId } = useParams<{
    projectId?: string;
    spoId?: string;
  }>();

  const projectId = options.projectId || routeProjectId;
  const directSpoId = options.spoId || routeSpoId;
  const shouldResolveByProject = !directSpoId && !!projectId;

  const {
    data: byProjectResponse,
    isLoading,
    isFetching,
    isError,
  } = useGetSPOByProjectQuery(projectId!, {
    skip: !shouldResolveByProject,
  });

  const resolvedSpoId = directSpoId || byProjectResponse?.data?._id;

  return {
    projectId,
    resolvedSpoId,
    isResolving: shouldResolveByProject && (isLoading || isFetching),
    isResolveError: shouldResolveByProject && isError,
  };
};
